/* BKS — Gardien de panier pour les selles configurées (2D / FUSION).
   05/10/2026 — CORRECTIF : Shopify DÉCOUPE la ligne « Options » (brique) en plusieurs lignes quand une remise
   automatique (ex. « Cadeau 200€ ») s'applique sur une partie de sa quantité. Les lignes brique d'un même
   _bks_id comptent désormais pour UNE pièce et leurs quantités s'ADDITIONNENT avant le contrôle anti-fraude
   (avant : la selle était retirée du panier à tort dès 200 € de panier).
   Lie la selle personnalisée à ses options (suppléments) via la propriété cachée _bks_id.
   Si le client retire une ligne (ou casse le compte / la quantité), TOUTE la selle est retirée.
   NOUVEAU : validation AU CLIC sur "Passer la commande" (bloque la course où le client
   retire l'option puis paie avant que le gardien réactif n'ait agi).

   08/10/2026 — CONFIGURATEURS V2 (chaque option = un vrai produit, rattaché à la selle). Deux analyses, UN interrupteur :
     · BKS_GUARD_V2 = false -> analyze05 : la fonction du 05/10, COPIÉE À L'OCTET (corps identique, contrôlé par
       construire/T0-portes.js), avec son message d'origine. Comportement d'aujourd'hui.
     · BKS_GUARD_V2 = true  -> analyzeV2 : groupes par _bks_id ; selle verrouillée à l'unité (on garde la pièce dont
       dépendent les options imbriquées) ; manifeste _bks_opts pour les selles v2 (option manquante -> selle retirée,
       option en trop -> ramenée, sans message) ; paniers hérités (briques, CUSTOM v1, 2D) : règles du 05/10 + quantités
       de selle additionnées + morceaux regroupés + pack facultatif ; option ou brique seule -> retirée sans message ;
       selle retirée par le client -> AUCUN message (l'ancien était faux).
   L'interrupteur est écrit par construire/G-interrupteurs.js depuis construire/interrupteurs.json, jamais à la main.
   Retour arrière du fichier entier : construire/retour/bks-cart-guard.05-10.js (version du 05/10, = thème publié). */
(function(){
  if(window.__bksCartGuard) return; window.__bksCartGuard=1;
  var BKS_GUARD_V2 = true; /* @@INTERRUPTEUR BKS_GUARD_V2@@ */
  var BUSY=false, TMR=null;
  var MSG="Une option payante a été retirée : ta selle personnalisée ne peut pas être commandée sans ses options. Elle a été enlevée du panier — reconfigure-la si besoin.";
  var MSG_A="Une option de ta selle configurée a été retirée : la selle ne peut pas être commandée sans elle. Elle a été enlevée du panier. Rouvre ton lien de configuration pour la retrouver.";
  var MSG_C="Une selle configurée se commande à l'unité. Pour une deuxième selle, repasse par le configurateur : ton lien garde ta configuration.";

  /* analyse le panier -> { updates, changed, removed } (removed = un bundle a été cassé) */
  function analyze05(cart){
    var groups={};
    (cart.items||[]).forEach(function(it){
      var p=it.properties||{}; var id=p._bks_id; if(!id) return;
      if(!groups[id]) groups[id]={base:null,supps:[],parts:0};
      if(p._bks_role==='base'){ groups[id].base=it; groups[id].parts=parseInt(p._bks_parts||'0',10)||0; }
      else groups[id].supps.push(it);
    });
    var updates={}, changed=false, removed=false;
    Object.keys(groups).forEach(function(id){
      var g=groups[id];
      var bricks=g.supps.filter(function(s){ return ((s.properties||{})._bks_role)==='brick'; });
      var autres=g.supps.length-bricks.length;
      var present=(g.base?1:0)+autres+(bricks.length?1:0);   // les morceaux d'une brique découpée = 1 pièce
      // brique de prix (FUSION "Options x N") : sa quantité DOIT valoir base.quantité x _bks_brickqty.
      var bq = g.base ? (parseInt((g.base.properties||{})._bks_brickqty||'0',10)||0) : 0;
      var tamper=false, brickPresent=false;
      if(g.base && bricks.length){ brickPresent=true; var somme=0; bricks.forEach(function(s){ somme+=s.quantity; }); if(bq && somme!==g.base.quantity*bq) tamper=true; }
      // brique attendue (bq>0) mais absente = fraude (client a retiré la ligne Options)
      if(bq && !brickPresent) tamper=true;
      if(!g.base || (g.parts && present!==g.parts) || tamper){
        if(g.base) updates[g.base.key]=0;
        g.supps.forEach(function(s){ updates[s.key]=0; });
        changed=true; removed=true;
      } else if(g.base){
        var q=g.base.quantity;
        g.supps.forEach(function(s){
          if(((s.properties||{})._bks_role)==='brick') return; // brique vérifiée ci-dessus
          if(s.quantity!==q){ updates[s.key]=q; changed=true; }
        });
      }
    });
    return { updates:updates, changed:changed, removed:removed };
  }

  /* ---------------- 08/10 : analyse v2 (fonction PURE : aucune requête, aucun effet) ---------------- */
  var PACK_VAR=54119771603285;
  var BRIQUES={'options-selle-fusion':1,'supplement-selle-scooter':1,'supplement-selle-velto':1,'options-selle-cross':1};
  var ENFANTS={opt:1,brick:1,supp:1,pack:1};
  function prp(it){ return it.properties||{}; }
  function role(it){ return prp(it)._bks_role||''; }
  function vid(it){ return String(it.variant_id||it.id||''); }
  function ent(v){ var n=parseInt(v,10); return isNaN(n)?0:n; }
  /* ramène un ensemble de lignes (morceaux d'une même pièce) à `cible` unités au total, dans l'ordre du panier */
  function ramener(lignes, cible, updates){
    var reste=cible;
    lignes.forEach(function(l){ var q=Math.min(l.quantity, Math.max(reste,0)); reste-=q; if(q!==l.quantity) updates[l.key]=q; });
  }
  /* manifeste "variante:quantité;variante:quantité" (ou "aucune") -> { variante: quantité } ou null si illisible */
  function manifeste(s){
    if(s==='aucune') return {};                          /* selle v2 sans option payante */
    if(typeof s!=='string' || !s.length) return null;
    var out={}, ok=true;
    s.split(';').forEach(function(x){
      var m=x.split(':'); if(m.length!==2){ ok=false; return; }
      var v=m[0].trim(), q=ent(m[1]);
      if(!v || !/^\d+$/.test(v) || q<1){ ok=false; return; }
      out[v]=(out[v]||0)+q;
    });
    return ok && Object.keys(out).length ? out : null;
  }
  function analyzeV2(cart){
    var items=cart.items||[], updates={}, msgA=false, msgC=false, removed=false;
    var groups={}, ordre=[];
    items.forEach(function(it){
      var p=prp(it), id=p._bks_id;
      if(!id){
        /* 0. option de configurateur achetée seule (fiche, API) ; 2. brique seule : retirées sans message */
        if(it.product_type==='Option configurateur' || BRIQUES[it.handle]) updates[it.key]=0;
        return;
      }
      if(!groups[id]){ groups[id]={bases:[],enfants:[]}; ordre.push(id); }
      if(p._bks_role==='base') groups[id].bases.push(it); else groups[id].enfants.push(it);
    });
    ordre.forEach(function(id){
      var g=groups[id];
      var retirer=function(){ g.bases.concat(g.enfants).forEach(function(l){ updates[l.key]=0; }); removed=true; };
      /* a. plus de selle : ses lignes partent, SANS message (le client a retiré la selle) */
      if(!g.bases.length){ g.enfants.forEach(function(l){ updates[l.key]=0; }); removed=true; return; }
      /* b. selle à l'unité : on garde la pièce dont dépendent les options imbriquées (E2), sinon la 1re */
      var parents={}; g.enfants.forEach(function(l){ if(l.parent_relationship && l.parent_relationship.parent_key) parents[l.parent_relationship.parent_key]=1; });
      var garde=g.bases[0], Qb=0;
      g.bases.forEach(function(b){ Qb+=b.quantity; if(parents[b.key]) garde=b; });
      g.bases.forEach(function(b){ var q=(b===garde)?1:0; if(b.quantity!==q) updates[b.key]=q; });
      if(Qb!==1) msgC=true;
      var bp=prp(garde);
      if(bp._bks_v==='2'){
        /* c. selle v2 : manifeste */
        var attendu=manifeste(bp._bks_opts);
        if(!attendu){ retirer(); msgA=true; return; }
        var parV={};
        g.enfants.forEach(function(l){
          var r=role(l);
          if(r==='opt'){ (parV[vid(l)]=parV[vid(l)]||[]).push(l); }
          else if(r==='brick' || BRIQUES[l.handle]) updates[l.key]=0;      /* brique dans un groupe v2 */
          /* pack / supp : facultatif, aucune contrainte */
        });
        var manque=false;
        Object.keys(attendu).forEach(function(v){
          var t=0; (parV[v]||[]).forEach(function(l){ t+=l.quantity; });
          if(t<attendu[v]) manque=true;
        });
        if(manque){ retirer(); msgA=true; return; }
        Object.keys(parV).forEach(function(v){
          if(!attendu[v]) parV[v].forEach(function(l){ updates[l.key]=0; });   /* variante non attendue */
          else ramener(parV[v], attendu[v], updates);                          /* en trop -> ramenée */
        });
        return;
      }
      /* d. hérité : briques (FUSION, SCOOTER, VELTO, CROSS), CUSTOM v1, 2D, LA BKS V2 */
      var parts=ent(bp._bks_parts), aBq=Object.prototype.hasOwnProperty.call(bp,'_bks_brickqty'), bq=ent(bp._bks_brickqty);
      var bricks=[], pieces={}, nPieces=0, packPresent=false;
      g.enfants.forEach(function(l){
        if(role(l)==='brick'){ bricks.push(l); return; }
        if(String(vid(l))===String(PACK_VAR)) packPresent=true;
        var cle=vid(l)+'|'+(prp(l)._bks_slot||'')+'|'+(prp(l)['Détail']||'');
        if(!pieces[cle]){ pieces[cle]=[]; nPieces++; }
        pieces[cle].push(l);
      });
      var present=1+nPieces+(bricks.length?1:0);
      var tamper=false;
      if(bq && !bricks.length) tamper=true;
      var somme=0; bricks.forEach(function(l){ somme+=l.quantity; });
      if(bricks.length && bq && somme<bq) tamper=true;
      /* pack facultatif : toléré absent seulement pour la famille à brique (_bks_brickqty posé), où il compte dans _bks_parts */
      if(parts && present!==parts && !(aBq && !packPresent && present===parts-1)) tamper=true;
      if(tamper){ retirer(); msgA=true; return; }
      if(bricks.length && bq && somme>bq) ramener(bricks, bq, updates);   /* brique montée -> ramenée, sans message */
      Object.keys(pieces).forEach(function(c){ var t=0; pieces[c].forEach(function(l){ t+=l.quantity; }); if(t!==1) ramener(pieces[c], 1, updates); });
    });
    var changed=Object.keys(updates).length>0;
    var message=[]; if(msgA) message.push(MSG_A); if(msgC) message.push(MSG_C);
    return { updates:updates, changed:changed, removed:removed, message:message.length?message.join('\n\n'):null };
  }

  var analyze = BKS_GUARD_V2 ? analyzeV2 : analyze05;
  /* le message à montrer : v2 -> celui de l'analyse (aucun quand la selle a été retirée par le client) ; 05/10 -> MSG si un lot est cassé */
  function texte(res){ return BKS_GUARD_V2 ? (res.message||null) : (res.removed ? MSG : null); }
  try { window.__bksGuard={ analyze:analyze, analyzeV2:analyzeV2, analyze05:analyze05, v2:BKS_GUARD_V2 }; } catch(e) {}

  function getCart(){ return fetch('/cart.js',{cache:'no-cache',headers:{'Accept':'application/json'}}).then(function(r){return r.json();}); }
  function applyUpdates(u, at){ var b={updates:u}; if(at) b.attributes=at; return fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(b)}); }

  /* 09/10/2026 — tour 2 des vérificateurs (v2 seulement) : les attributs de panier « Contrôle atelier <_bks_id> » et
     « _bks_ecart_<_bks_id> » (bloc commun des configurateurs) suivent LEUR selle. Shopify les garde même après le retrait de la
     selle ou /cart/clear.js : une commande suivante porterait une fausse alerte. On efface (valeur vide) ceux dont la selle n'est
     plus au panier, sur /cart et au clic « Paiement » seulement — jamais sur une page de configurateur, où l'attribut est posé
     juste AVANT l'ajout de sa selle. Anciennes clés sans identifiant (« Contrôle atelier », « _bks_ecart ») : identifiant lu
     dans la valeur. La propriété de ligne _bks_repli et le contrôle S1 des commandes font foi. */
  function attributsPerimes(cart){
    var ids={}, out={}, n=0, a=(cart&&cart.attributes)||{};
    (cart.items||[]).forEach(function(it){ var p=it.properties||{}; if(p._bks_id) ids[p._bks_id]=1; });
    Object.keys(a).forEach(function(k){
      var v=(a[k]===null||a[k]===undefined)?'':String(a[k]), id=null;
      if(!v) return;
      if(k.indexOf('Contrôle atelier ')===0) id=k.slice(17);
      else if(k.indexOf('_bks_ecart_')===0) id=k.slice(11);
      else if(k==='Contrôle atelier') id=v.split(' ')[1]||'';
      else if(k==='_bks_ecart') id=v.split(':')[0];
      else return;
      if(!id || !ids[id]){ out[k]=''; n++; }
    });
    return n?out:null;
  }
  function surPanier(){ var tv=window.themeVariables&&window.themeVariables.settings; return !!((tv&&tv.pageType==='cart')||/\/cart\/?$/.test(location.pathname)); }
  try { window.__bksGuard.attributsPerimes=attributsPerimes; } catch(e) {}

  /* gardien réactif : après une modif de panier, corrige/retire et recharge */
  function schedule(){ if(TMR) clearTimeout(TMR); TMR=setTimeout(run, 250); }
  function run(){
    if(BUSY) return;
    getCart().then(function(cart){
      var res=analyze(cart);
      var at=(BKS_GUARD_V2 && surPanier()) ? attributsPerimes(cart) : null;
      if(!res.changed){ if(at) applyUpdates({}, at).catch(function(){}); return; }
      BUSY=true;
      applyUpdates(res.updates, at).then(function(){
        var t=texte(res); if(t){ try{ alert(t); }catch(e){} }
        window.location.reload();
      }).catch(function(){ BUSY=false; });
    }).catch(function(){});
  }

  /* ---- protection AU MOMENT DU PAIEMENT (ferme la course) ---- */
  var CHECKING=false;
  function guardCheckout(e){
    if(CHECKING) return;                 // déjà validé -> laisser passer
    e.preventDefault(); e.stopImmediatePropagation();
    CHECKING=true;
    getCart().then(function(cart){
      var res=analyze(cart);
      var t=texte(res);
      if(res.removed || (BKS_GUARD_V2 && t)){   // bundle cassé (ou selle remise à l'unité) -> on bloque, on nettoie, on montre
        applyUpdates(res.updates).then(function(){ if(t){ try{ alert(t); }catch(e){} } window.location.reload(); })
          .catch(function(){ CHECKING=false; });
      } else {                            // panier OK -> on va au paiement
        var at=BKS_GUARD_V2 ? attributsPerimes(cart) : null;
        if(res.changed){ applyUpdates(res.updates, at).then(function(){ window.location.href='/checkout'; }); }
        else if(at){ applyUpdates({}, at).catch(function(){}).then(function(){ window.location.href='/checkout'; }); }
        else window.location.href='/checkout';
      }
    }).catch(function(){ window.location.href='/checkout'; }); // erreur réseau : ne pas bloquer une vente légitime
  }
  document.addEventListener('click', function(e){
    var b=e.target && e.target.closest && e.target.closest('[name="checkout"], a[href$="/checkout"], a[href*="/checkout?"]');
    if(b) guardCheckout(e);
  }, true);
  document.addEventListener('submit', function(e){
    if(e.submitter && e.submitter.name==='checkout') guardCheckout(e);
  }, true);

  /* masque les boutons de paiement express (Shop Pay/PayPal/GPay) quand un bundle est présent
     -> ils court-circuiteraient la validation ci-dessus */
  function hideExpressIfBundle(){
    getCart().then(function(cart){
      var hasBundle=(cart.items||[]).some(function(it){ return (it.properties||{})._bks_role==='base'; });
      if(!hasBundle) return;
      document.querySelectorAll('[class*=dynamic-checkout], shopify-accelerated-checkout, .shopify-payment-button, [class*=accelerated-checkout]').forEach(function(el){ el.style.display='none'; });
    }).catch(function(){});
  }

  /* ---- interception des modifs de panier (fetch + XHR) ---- */
  function watch(u){ return typeof u==='string' && /\/cart\/(change|update|add|clear)/.test(u); }
  var of=window.fetch;
  if(of){ window.fetch=function(){ var a=arguments; var u=(a[0]&&a[0].url)||a[0]||''; var pr=of.apply(this,a);
    try{ if(watch(u)){ pr.then(function(){ schedule(); hideExpressIfBundle(); }).catch(function(){}); } }catch(e){}
    return pr; }; }
  var ox=window.XMLHttpRequest;
  if(ox){ var oo=ox.prototype.open; ox.prototype.open=function(m,u){ this.__bksU=u; return oo.apply(this,arguments); };
    var os=ox.prototype.send; ox.prototype.send=function(){ var self=this;
      try{ if(watch(self.__bksU)){ self.addEventListener('load',function(){ schedule(); hideExpressIfBundle(); }); } }catch(e){}
      return os.apply(this,arguments); }; }

  function init(){ run(); hideExpressIfBundle(); }
  if(document.readyState!=='loading'){ init(); } else { document.addEventListener('DOMContentLoaded', init); }
})();
